import { keyMapItem, LayerKeysMap, Macro, PressureMacro } from '../../types/mouseKeys'
import { FeatureBase } from '../FeatureBase'

// 扩展功能注册表
declare module '../FeatureMap' {
  export interface DeviceFeatureMap {
    mouseKeys: IMouseKeyFeature
  }
}

export interface IMouseKeyFeature {
  // 获取鼠标按键表
  getMouseKeyMap(): Promise<LayerKeysMap>
  // 设置鼠标按键表
  setMouseKeyMap(map: LayerKeysMap): Promise<void>
  // 设置指定鼠标按键
  setMouseKey(key: keyMapItem, index: number): Promise<void>
  // 获取宏列表
  getMacroList(): Promise<Macro[]>
  // 流式获取宏列表
  getMacroListStream(batchSize?: number): AsyncIterable<Macro[]>
  // 获取指定组的宏
  getMacroByIndex(index: number): Promise<Macro>
  // 设置指定组宏数据
  setMacroByIndex(macro: Macro, index: number): Promise<void>
  // 获取指定组的压枪宏
  getPressureMacroByIndex(index: number): Promise<PressureMacro>
  // 设置指定组压枪宏数据
  setPressureMacroByIndex(macro: PressureMacro, index: number): Promise<void>
}

export class mouseKeyFeature extends FeatureBase implements IMouseKeyFeature {
  // 获取鼠标按键表
  getMouseKeyMap(): Promise<LayerKeysMap> {
    return this.unsupported('mouseKeyFeature.getMouseKeyMap')
  }
  // 设置鼠标按键表
  setMouseKeyMap(_map: LayerKeysMap): Promise<void> {
    return this.unsupported('mouseKeyFeature.setMouseKeyMap')
  }
  // 设置指定鼠标按键
  setMouseKey(_key: keyMapItem, _index: number): Promise<void> {
    return this.unsupported('mouseKeyFeature.setMouseKey')
  }
  // 获取宏列表
  getMacroList(): Promise<Macro[]> {
    return this.unsupported('mouseKeyFeature.getMacroList')
  }
  // 流式获取宏列表
  getMacroListStream(_batchSize?: number): AsyncIterable<Macro[]> {
    return this.unsupported('mouseKeyFeature.getMacroListStream')
  }
  // 获取指定组的宏
  getMacroByIndex(_index: number): Promise<Macro> {
    return this.unsupported('mouseKeyFeature.getMacroByIndex')
  }
  // 设置指定组宏数据
  setMacroByIndex(_macro: Macro, _index: number): Promise<void> {
    return this.unsupported('mouseKeyFeature.setMacroByIndex')
  }
  // 获取指定组的压枪宏
  getPressureMacroByIndex(_index: number): Promise<PressureMacro> {
    return this.unsupported('mouseKeyFeature.getPressureMacroByIndex')
  }
  // 设置指定组压枪宏数据
  setPressureMacroByIndex(_macro: PressureMacro, _index: number): Promise<void> {
    return this.unsupported('mouseKeyFeature.setPressureMacroByIndex')
  }
}
